import defaultProfileImage from "../assets/images/icons/default-profile-image.svg";
import { API_URL } from "../http";
import { IUser } from "../models/User";

export const setProfileImage = (user: IUser | null) => {
  if (!user || !user.profileImagePath) {
    return defaultProfileImage;
  } else {
    return API_URL + user.profileImagePath;
  }
};
